import { useCallback } from 'react';

export default function useEventValueChange(onChange) {
	return useCallback((event) => {
		if (onChange) {
			onChange(event.target.value);
		}
	}, [onChange]);
}
